// extracted by mini-css-extract-plugin
module.exports = {"default":"ConfigsList__default__34Hzo"};